var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-transition",class:[_vm.onTransition && _vm.name ? ("page-transition-" + _vm.name) : ''],style:(_vm.style)},[_c('transition',{attrs:{"name":_vm.name},on:{"before-enter":_vm.handleBeforeEnter,"after-enter":_vm.handleAfterEnter,"after-leave":_vm.handleAfterLeave}},[_vm._t("default")],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54957fe6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./ya/page-transition.vue
// module id = E2Ak
// module chunks = 5